import { FlexProps, Flex } from '@chakra-ui/react';

const ProductFieldColumn = (props: FlexProps) => <Flex flex={1} justifyContent="flex-start" pb={0.5} {...props} />;

export default ProductFieldColumn;
